import { render, staticRenderFns } from "./NuevoBaja.vue?vue&type=template&id=7c0124c3&"
import script from "./NuevoBaja.vue?vue&type=script&lang=js&"
export * from "./NuevoBaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports